import Cookies from "js-cookie";
import styles from "../home/Home.module.css";
import {API, Entities} from "../../utils/Api";
import {Hero,TicketHero} from "../../blocks/hero/Hero";
import {useLoaderData, useNavigate, useOutletContext} from "react-router-dom";
import {useEffect} from "react";
import {AboutUs, Countdown} from "../../blocks/aboutus/AboutUs";
import {CounterArticle} from "../../blocks/counterarticle/CounterArticle";
import {Topics} from "../../blocks/topics/Topics";
import {Opinion} from "../../blocks/opinion/Opinion";
import {Footer} from "../../blocks/footer/Footer";
import {PrimaryButton, SecondaryButton} from "../../components/button/Button";
import {Sponsors} from "../../blocks/sponsors/Sponsors";

export default function HomePage({logout=false}){
    const navigate = useNavigate();
    const context = useOutletContext();
    const data = useLoaderData();
    const user=context.user;


    var sponsors = data.sponsors;

    useEffect(()=>{
        if(logout){
            handleLogout();
        }
    })
    function handleLogout() {
        API.request(Entities.logout).then((response)=>{
            Cookies.remove('user');
            if(parseInt(response.status) !== 1){
                navigate('/home');
            }
            else{
                navigate(0);
            }
        });
    }

    function handleAPI(){
        API.request(Entities.test,{}).then((response)=>{
            if(parseInt(response.status) === 1){
                document.getElementById('msg').innerHTML += `<div class="d-inline-block border">${response.message}</div>`;
            }
            else{
                Cookies.remove('user');
                navigate('/home');
            }
        });

    }

    return (<>
            <Hero
                url={"/benefitshare/img/homebg1.jpg"}
                megaphone={"For Shaping Success"}
                titles={["BeneFit SHARE", "Konferencia 2025"]}
                shortdescription={'2025.05.25. Helyszín neve és címe'}
            >
                <PrimaryButton href={'/jegyek'} primaryText={'Jegyvásárlás'}></PrimaryButton>
            </Hero>
            <AboutUs enddate={"2025-05-20 08:00:00"} counter={17}></AboutUs>
            <Topics></Topics>
            <Sponsors sponsors={sponsors}></Sponsors>
            <TicketHero titles={["Sharing ideas, shaping success.Big ideas for happy employees."]} megaphone={"Let's make something great work together."}>
                <PrimaryButton href={'/jegyek'} primaryText={'Jegy vásárlása'} secondaryText={"Biztosítsd a helyedet"}></PrimaryButton>
            </TicketHero>
            <Footer></Footer>

        </>
    );
}

export async function SponsorLoader(){  // Az async kulcsszó kell a Promise kezeléséhez
    try {
        const response = await API.rest(Entities.sponsor, "GET"); // Várjuk meg az API választ
        return {
            sponsors: response,
        };
    } catch (error) {
        console.error("Hiba történt az API hívás során:", error);
        return { presenters: [],filters:[] }; // Hiba esetén üres tömböt adunk vissza
    }
}